import React, { Component } from 'react';

class Footer extends Component {
  
  	render() {
  		return (
  			<div id="footer" className="footer">
  				
  			</div>
  		)
  	}
}

export default Footer;
